import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stepper-navigation',
  standalone: false,
  templateUrl: './stepper-navigation.component.html',
  styleUrl: './stepper-navigation.component.scss',
})
export class StepperNavigationComponent {
  @Input() currentStep!: number;
  @Input() steps: any[] = [];
  @Input() isNextDisabled: boolean = false;
  @Output() stepChangeEmitter: EventEmitter<number> =
    new EventEmitter<number>();

  handleStepChange(stepnumber: number) {
    if (stepnumber === 1 && (this.isNextDisabled || this.currentStep === 2)) {
      return;
    }
    this.stepChangeEmitter.emit(stepnumber);
  }
}
